import { render, staticRenderFns } from "./WorkOrdersMoney.vue?vue&type=template&id=2a546d9d&"
import script from "./WorkOrdersMoney.vue?vue&type=script&lang=js&"
export * from "./WorkOrdersMoney.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrdersMoney.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports